module.exports = __webpack_public_path__ + "img/分支箱.a06464ff.png";